async function logoutCleanup() {
    try {
        const registration = await navigator?.serviceWorker?.ready;
        const subscription = await registration?.pushManager?.getSubscription();
        if (subscription) {
            await subscription.unsubscribe();
            console.log("previous push subscription has been removed");
        }
    } catch (error) {
        console.log('error: ', error);
    }
}

export { logoutCleanup }